import $ from "jquery";
import debug from 'bows/dist/bows.min.js';

//const linksToAnchors = $('ul#mega-menu-modern_global a[href*="#"]');
const linksToAnchors = $('*:not(.owl-carousel) a[href*="#"]:not(.kt-tab-title)');

const log = debug("scroll");
const $jmm = $('.jump-menu-mobile');

export function anchorLinkHandler(e) {
	
	// /alert('whyyy');
	let href = $(this).prop('hash');
	let pathname = $(this).prop('pathname');
	let $where = $(href);
	console.log('Starting jump element ' + href);
	if ($where.length && $($where).hasClass('is-style-modal-content')) {
		console.log('modal!');
		$($where).modal();
		return false;
	} else if ($where.length) {
		e.preventDefault();
		console.log('Found jump element ' + href);
		if ($('#mega-menu-wrap-modern_global .mega-menu-toggle').hasClass('mega-menu-open')){
			
			$('#mega-menu-wrap-modern_global .mega-menu-toggle').trigger( "click" );
		}
		var elem = document.querySelector(href);
		var topDistance = elem.offsetTop;//getBoundingClientRect().top;
		const rect = elem.getBoundingClientRect();
		topDistance = rect.top + window.scrollY;
		//let topDistance = $where.offset().top;
		let $header = $('#header-modern');
		if (!$('#header-modern').length){
			$header = $('.header_microsite');
		}
		/*if ($jmm.css('display') === 'block') {
			topDistance -= 40;
		} else {
			topDistance -= 80;
		}*/
		let $offset = 75;
		if ($(window).width()<901){
			$offset = 80;
		}
		topDistance = parseInt(topDistance) - $header.height() - $offset;
		$(window).scrollTop(topDistance);
		document.scrollingElement.scrollTop = topDistance;
		$('.debug-element').html(topDistance + ' ' +href);
		console.log('vert scroll ' + topDistance);
		//window.history.hash = href;
		//if ($(location).attr("pathname") == pathname){

			window.history.pushState(null, null, href);
			/*
			$('html, body').animate({ scrollTop: topDistance }, 500, function () {
				let current = $(`.jump-menu__link[href="${href}"]`);
				if (current.length) {
					let text = current.eq(0).text();
					$('.jump-menu-mobile').find('.dropdown__select').text(text);
					$('.jump-menu__link--mobile').removeClass('jump-menu__link--active');
					$('.jump-menu__item').children().removeClass('jump-menu__link--active');
					current.addClass('jump-menu__link--active');
				}

				setTimeout(() => {
					if ($header.hasClass('headroom--not-top') === true) {
						$header.removeClass('headroom--pinned').addClass('headroom--unpinned');
					}
				}, 100);

			});*/
			
			e.preventDefault();
		//}
	}


	// log(topDistance);
	// const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);


	// const targetID = this.getAttribute("href");
	// const targetCheck = targetID.split('#');

	// if (targetCheck[1] === '') { return; }

	// const targetAnchor = document.querySelector(targetID);
	// if (!targetAnchor) return;
	// let originalTop = distanceToTop(targetAnchor);

	// if ($jmm.css('display') === 'block') {

	// 	originalTop -= 20;
	// }

	// window.scrollBy({ top: originalTop, left: 0, behavior: "smooth" });

	// const checkIfDone = setInterval(function () {
	// 	const atBottom =
	// 		window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
	// 	if (distanceToTop(targetAnchor) === 0 || atBottom) {
	// 		targetAnchor.tabIndex = "-1";
	// 		targetAnchor.focus();

	// 		window.history.pushState("", "", targetID);
	// 		clearInterval(checkIfDone);

	// 	}
	// 	targetAnchor.addEventListener("blur", function () {
	// 		targetAnchor.removeAttribute('tabIndex');

	// 	});

	// 	log('done');
	// let current = $(`.jump-menu__link[href="${targetID}"]`);
	// if (current.length) {
	// 	let text = current.eq(0).text();
	// 	$('.jump-menu-mobile').find('.dropdown__select').text(text);
	// 	$('.jump-menu__link--mobile').removeClass('jump-menu__link--active');
	// 	$('.jump-menu__item').children().removeClass('jump-menu__link--active');
	// 	current.addClass('jump-menu__link--active');
	// }
	// }, 100);
}

export function init() {
	console.log('init scroll jumpy thing');
	//log(`scroll init`);
	console.log(linksToAnchors);
	$(linksToAnchors).off();
	$(linksToAnchors).addClass('fancy-jump');
	if (linksToAnchors.length) {
		linksToAnchors.on('click', anchorLinkHandler);
	}
	$('.owl-carousel').on('click', 'a[href*="#"]', anchorLinkHandler);
/*
	$("ul#mega-menu-modern_global").on("mmm:showMobileMenu", function() {
		let megaAnchors = $('ul#mega-menu-modern_global a[href^="#"]');
		console.log(megaAnchors);
		if(megaAnchors.length){
			megaAnchors.on('click', anchorLinkHandler);
		}
	});*/
}

export default {
	init: init,
	anchorLinkHandler: anchorLinkHandler
};
